module.exports = __webpack_public_path__ + "static/Oswald-Regular-e605f2f859072ed0443aeda5adec4181.ttf";